// @ts-nocheck
import ActionBarItem from '@rio-cloud/rio-uikit/ActionBarItem';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { showChangeLog } from '@/actions/changelogActions';
import { ROUTE_PATH_START } from '@/constants';

import NonMatchingLink from './NonMatchingLink';

const { Icon, List, ListItem, Popover } = ActionBarItem;

const ServiceInfoComponentWithoutInjection = ({ handleChangeLogClickEvent }) => (
    <ActionBarItem id='serviceInfo' data-testId='service-info'>
        <Icon>
            <span className='icon uikit-icon icon-info-sign' />
        </Icon>
        <Popover title={<FormattedMessage id='intl-msg:pdc' />}>
            <List>
                <ListItem iconName='hand-right'>
                    <div className='display-flex align-items-center gap-5'>
                        <NonMatchingLink to={ROUTE_PATH_START}>
                            <FormattedMessage id='intl-msg:landingPage.heading' />
                        </NonMatchingLink>
                    </div>
                </ListItem>
                <ListItem iconName='exclamation-sign' onClick={handleChangeLogClickEvent}>
                    <FormattedMessage id='intl-msg:changelog.whatsNew' />
                </ListItem>
            </List>
        </Popover>
    </ActionBarItem>
);

ServiceInfoComponentWithoutInjection.propTypes = {
    handleChangeLogClickEvent: PropTypes.func.isRequired,
};

const ServiceInfoComponent = props => {
    const dispatch = useDispatch();
    const handleChangeLogClickEvent = () => dispatch(showChangeLog());

    return <ServiceInfoComponentWithoutInjection {...props} handleChangeLogClickEvent={handleChangeLogClickEvent} />;
};

export { ServiceInfoComponentWithoutInjection };
export default injectIntl(ServiceInfoComponent);
